import { Component } from "@angular/core";
import { CONFIG } from "app/shared/constants/config";
import { MatDialogRef } from "@angular/material/dialog";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-info",
  templateUrl: "./info.component.html",
  styleUrls: ["./info.component.scss"],
  imports: [NgIf],
})
export class InfoComponent {
  public version: string = CONFIG.VERSION;
  public commitInfo?: string = CONFIG.COMMIT_INFO;

  constructor(protected dialogRef: MatDialogRef<InfoComponent>) {}

  public close(): void {
    this.dialogRef.close();
  }
}
